import { fetchWrapper } from '@/_helpers';

const getEmailAccounts = () => fetchWrapper.get('email-integrations/accounts');

const authorizeEmail = ({ provider }) => {
    if (!provider) {
        throw new Error('Email provider is required');
    }
    return fetchWrapper.get(`email-integrations/authorize?provider=${provider}`);
};

const disconnectEmail = ({ accountId }) => fetchWrapper.delete(`email-integrations/accounts/${accountId}`);

const updateEmailChannel = (accountId, body) =>
    fetchWrapper.put(`email-integrations/accounts/${accountId}/channel`, body);

export const emailIntegrationService = {
    getEmailAccounts,
    authorizeEmail,
    disconnectEmail,
    updateEmailChannel,
};
